import { useState } from "react"

import { useTranslation } from "@/hooks/useTranslation"
import { useAgentCoreCloudConnection } from "@/pages/DeploymentsPage/components/organisms/AgentCoreCloudConnection"
import {
  AgentPlatformTab,
  CLOUD_CONNECTION_METHOD,
  useSensorMethods
} from "@/pages/DeploymentsPage/components/organisms/AgentPlatformTab"
import { getAgentCorePlatform } from "./helpers"

import type { AgentPlatformMethod } from "@/pages/DeploymentsPage/components/organisms/AgentPlatformTab"
import type { AgentCoreTabProps } from "./AgentCoreTab.types"

// The agentless cloud connection, offered first, next to the sensors'
export const AgentCoreTab = (props: AgentCoreTabProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "deployments" })
  const platform = getAgentCorePlatform(props.version)
  const sensorMethods = useSensorMethods(platform, props)
  const [method, setMethod] = useState(CLOUD_CONNECTION_METHOD)
  const cloud = useAgentCoreCloudConnection(method === CLOUD_CONNECTION_METHOD)
  const cloudMethod: AgentPlatformMethod = {
    key: CLOUD_CONNECTION_METHOD,
    label: t("agentPlatform.deployment.cloudConnection"),
    render: () => cloud.steps
  }

  return (
    <AgentPlatformTab
      platform={platform}
      methods={[cloudMethod, ...sensorMethods]}
      defaultMethod={CLOUD_CONNECTION_METHOD}
      onMethodChange={setMethod}
    >
      {cloud.content}
    </AgentPlatformTab>
  )
}
